import s from "xss";
const r = {
  b: [],
  strong: [],
  i: [],
  a: ["href", "title", "target", "class"],
  br: [],
  span: ["class"],
  li: ["class"],
  p: []
};
function e(t) {
  return s(t, { whiteList: r, stripIgnoreTag: !0 });
}
export {
  e as sanitize
};
